import React from 'react';
import FinalFormInputWrapper from './FinalFormInputWrapper';
import { SelectWithTags } from 'components/forms';
import { WrapperProps } from './SelectInputWrapper';

const TextInputWrapper: React.FC<WrapperProps> = (props) => (
  <FinalFormInputWrapper {...props} component={SelectWithTags} />
);

export default TextInputWrapper;
